import { render, staticRenderFns } from "./OrganizationSearch.vue?vue&type=template&id=6ce2bc92&"
import script from "./OrganizationSearch.vue?vue&type=script&lang=js&"
export * from "./OrganizationSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports